import { AddMarketComponent } from './../add-market/add.component';
import   Swal  from 'sweetalert2';
import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EditComponent } from '../edit/edit.component';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListMarketComponent implements OnInit {

  stores;
  constructor(private dialog:MatDialog,private service:GlobalService,private spinner:NgxSpinnerService) { }

  ngOnInit(): void {
    this.bannerList()
  }

  bannerList(type = 4 , status = 1){
    this.spinner.show()
    this.service.allUsers(type , status).pipe(map(res=>res)).subscribe(res=>{
    this.spinner.hide()
    console.log('res')
      console.log(res)
      this.stores=res
    })
  }

  deleteApp(category_id){
    this.spinner.show()
    this.service.deleteTag(category_id).subscribe(res=>{
      this.spinner.hide()
      Swal.fire(
        'نجاح',
        'تم حذف التاج بنجاح',
        'success'
        )
        this.bannerList()
    })
  }
  
  // viewApp(category){
  //   let dialogRef = this.dialog.open(CategoryDetailsComponent, {
  //     data:category,
  //     height: '380px',
  //     width: '400px',
  //   });
  // }

  editPackage(category){
    console.log(category)
    let dialogRef = this.dialog.open(EditComponent, {
      data:category,
      height: '650px',
      width: '600px',
    });
    dialogRef.afterClosed().subscribe(result => {
      this.bannerList()
    });
  }

  assignMarket(category){
    console.log(category)
    let dialogRef = this.dialog.open(AddMarketComponent, {
      data:category,
      height: '650px',
      width: '600px',
    });
    dialogRef.afterClosed().subscribe(result => {
      this.bannerList()
    });
  }
}
